import React, { useState } from 'react';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import useAppContext from 'flow/hooks/useAppContext';
import { CallStrategy } from 'flow/types/Queue';
import { StrategyState } from 'flow/utils';
import StageProgress from './StageProgress';

import GuideImage1 from 'images/call_strategy_round_robin.gif';
import GuideImage2 from 'images/call_strategy_sequential.gif';
import GuideImage3 from 'images/call_strategy_call_all.gif';
import GuideImage4 from 'images/call_strategy_least_recent.gif';
import GuideImage5 from 'images/call_strategy_fewest_calls.gif';
import GuideImage6 from 'images/call_strategy_random.gif';

const stageImages = [
    GuideImage1,
    GuideImage2,
    GuideImage3,
    GuideImage4,
    GuideImage5,
    GuideImage6,
];

const stageType = [
    'Roundrobin',
    'Sequential',
    'RingAll',
    'Leastrecent',
    'FewestCalls',
    'Random',
];

interface Props {
    strategy: CallStrategy;
}

const CallStrategyGuide = ({ strategy }: Props) => {
    const { i18next } = useAppContext();
    const [current, setCurrent] = useState(
        stageType.indexOf(StrategyState[strategy].value),
    );

    return (
        <div className="flex grow flex-col items-center gap-2">
            <div className="flex w-full flex-col items-center gap-2 self-center rounded-md border bg-white p-6 dark:bg-gray-100">
                <div className="flex w-full items-center justify-between">
                    {current > 0 ? (
                        <IconButton
                            aria-label={i18next.t('action.previous')}
                            onClick={() => setCurrent((current) => current - 1)}
                        >
                            <Icon iconKey="arrow_back" />
                        </IconButton>
                    ) : (
                        <div className="size-8" />
                    )}

                    <p className="text-sm font-bold text-gray-800">
                        {i18next.t(
                            `Queue.CallStrategy.Item.${stageType[current]}`,
                        )}
                    </p>

                    {current < stageType.length - 1 ? (
                        <IconButton
                            aria-label={i18next.t('action.next')}
                            onClick={() => setCurrent((current) => current + 1)}
                        >
                            <Icon iconKey="arrow_forward" />
                        </IconButton>
                    ) : (
                        <div className="size-8" />
                    )}
                </div>

                <img
                    className="w-60"
                    src={stageImages[current]}
                    alt={i18next.t(
                        `Queue.CallStrategy.Item.${stageType[current]}`,
                    )}
                />

                <p className="h-8 text-center text-xs text-gray-500">
                    {i18next.t(
                        `Queue.CallStrategy.Item.Message.${stageType[current]}`,
                    )}
                </p>
            </div>

            <StageProgress
                stages={stageType.length}
                currentStage={current}
                handleSelect={setCurrent}
                selectedColor="bg-main"
            />
        </div>
    );
};

export default CallStrategyGuide;
